import { render, staticRenderFns } from "./Holding.vue?vue&type=template&id=25c8b06e&scoped=true&"
import script from "./Holding.vue?vue&type=script&lang=js&"
export * from "./Holding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8b06e",
  null
  
)

export default component.exports